
import VideoControls from './video-controls';
import InfoMessage from './info-message';
import OffersList from './offers';
import AiCarSearch from './ai-car-search';

function init() {
  VideoControls.init();
  InfoMessage.init();
  OffersList.init();
  AiCarSearch.init();
}

export { init };
